<template>
  <div>
    <div
      v-if="hasSocialMediaChannels"
      class="inline-block px-2 text-grey-60 font-normal cursor-pointer transition transition-text hover:text-grey-40 py-2"
      @click="openShareModal"
    >
      <XIcon
        name="fa/light/sign-out"
        class="leading-none mr-1"
        :class="$style['share-icon']"
      />
      <span>{{ $t('event.timeline.socials.share') }}</span>
    </div>

    <a
      v-if="hasDownloadChannel"
      :href="downloadUrl"
      v-analytics:click="{
        category: 'download',
        reactionId: reactionId
      }"
      class="inline-block px-2 text-grey-60 cursor-pointer font-normal transition transition-text no-underline hover:text-grey-40"
      target="_blank"
    >
      <XIcon
        name="fa/light/download"
        class="leading-none mr-1"
      />
      <span>{{ $t('event.timeline.download') }}</span>
    </a>
  </div>
</template>

<script>
import XShareModal from './ShareModal'

export default {
  props: {
    reactionId: {
      type: String
    },
    showUrl: {
      type: String
    },
    downloadUrl: {
      type: String
    },
    shareChannels: {
      type: Array
    },
    shareMessage: {
      type: String
    },
    shareHashtags: {
      type: Array
    },
    shareDescription: {
      type: String
    }
  },

  computed: {
    hasSocialMediaChannels () {
      return !!this.shareChannels.find(channel => channel !== 'download')
    },

    hasDownloadChannel () {
      return this.shareChannels.includes('download')
    }
  },

  methods: {
    openShareModal () {
      this.$modal.show(XShareModal, {
        reactionId: this.reactionId,
        showUrl: this.showUrl,
        shareChannels: this.shareChannels,
        shareMessage: this.shareMessage,
        shareHashtags: this.shareHashtags,
        shareDescription: this.shareDescription
      })
    }
  }
}
</script>

<style module>
.share-icon {
  transform: rotate(-90deg);
}
</style>
